module.exports = __webpack_public_path__ + "76b0b7b5d9ad9d0314d2a411e04513e7.svg";